import { NgModule, Component, inject, OnInit, ViewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';
//import { UserAdminComponent } from "./components/user-admin/user-admin.component";
import { ToolbarComponent } from "./components/toolbar/toolbar.component";
import { MatDrawer } from '@angular/material/sidenav';
import { SideBarService } from './services/sidebar.service';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})

export class AppComponent implements OnInit{
  title = 'Job_Offer';
  authService = inject(AuthService);

  @ViewChild(MatDrawer) 
  public drawer: MatDrawer = new MatDrawer();
   
  ngOnInit() {
    this.sideBarService.change.subscribe(isOpen => {
      this.drawer.toggle();
    });
  }

  constructor(private sideBarService: SideBarService) {}

  get isLoggedIn() {
    //return false;
    return this.authService.authenticated();
  }
}
